export default function PractitionerConsentForm(props) {
  const version = '20250528';

  const listStyle = {
    paddingLeft: 20,
    marginTop: 7,
    marginBottom: 20
  };

  const listItemStyle = {
    marginLeft: 10,
    marginBottom: 8,
  };

  return (
    <div style={{ }}>
      <strong>TruBalance Practitioner Agreement</strong><br /><br />
      This agreement (“Agreement”) is entered into between <strong>RenuHealth LLC d/b/a TruBalance Bioenergetics</strong> (“Business” and/or “TruBalance”) and <strong>{props.practitionerName || '[Practitioner’s Name or Business]'}</strong> (“Practitioner”).<br /><br />
      By signing up for TruBalance services, the Practitioner agrees to the following terms and conditions:<br /><br />

      <strong>1. Services Provided</strong><br />
      TruBalance agrees to perform distance bioenergetic scans for the Practitioner’s clients under the following conditions:<br /><br />
      <strong>1.1</strong> The Practitioner is responsible for scheduling each client session and securing the reservation with a $50 reservation fee.<br /><br />
      <strong>1.2</strong> Once a session is scheduled, TruBalance will mail a testing kit to the client. The client is responsible for returning the kit and completing all necessary forms before testing.<br /><br />
      <strong>1.3</strong> TruBalance will make every reasonable effort to complete the scan as scheduled. However, TruBalance is not responsible if the client fails to:<br />
      <ul style={listStyle}>
        <li style={listItemStyle}>Return their sample in time</li>
        <li style={listItemStyle}>Complete required forms before testing</li>
      </ul>
      <strong>1.4</strong> Refund & Rescheduling Policy:<br />
      <ul style={listStyle}>
        <li style={listItemStyle}>The $50 reservation fee is non-refundable once the testing kit has been mailed.</li>
        <li style={listItemStyle}>If the session is rescheduled 48+ hours in advance, the $50 will be applied to the rescheduled session.</li>
        <li style={listItemStyle}>If the client fails to reschedule/cancel within 48 hours or does not return their sample on time, TruBalance reserves the right to retain the $50 fee to cover mailing and administrative costs.</li>
        <li style={listItemStyle}>Late sample returns may incur an additional $50 fee for rescheduling.</li>
        <li style={listItemStyle}>If TruBalance is unable to perform the scan due to an internal issue, the Practitioner may choose to reschedule or receive a full refund.</li>
      </ul><br />

      <strong>2. Practitioner Benefits</strong><br />
      As part of the agreement, the Practitioner will receive:<br />
      <ul style={listStyle}>
        <li style={listItemStyle}>Ongoing membership to the TruBalance Practitioner App for charting, communication, scheduling, and training.</li>
        <li style={listItemStyle}>1:1 onboarding call with a TruBalance employee.</li>
        <li style={listItemStyle}>Personal Bioenergetic Scan results + imprint (upon return of testing kit).</li>
        <li style={listItemStyle}>1:1 consultation to review their own bioenergetic scan results.</li>
        <li style={listItemStyle}>Up to 4 hours of customization setup, including adding supplements and customizing scan protocols. (Additional customization time available at $100/hr).</li>
      </ul><br />

      <strong>3. Payment & Practitioner Responsibilities</strong><br /><br />
      <strong>3.1</strong> Card on File Requirement<br />
      The Practitioner is required to store a payment card on file. This card will be used to:<br />
      <ul style={listStyle}>
        <li style={listItemStyle}>Charge the $50 reservation fee at the time of booking.</li>
        <li style={listItemStyle}>Charge the remaining session balance on the scheduled scan date.</li>
      </ul>
      <strong>3.2</strong> Practitioner’s Billing Responsibility<br />
      <ul style={listStyle}>
        <li style={listItemStyle}>The Practitioner is responsible for charging their own clients for the service.</li>
        <li style={listItemStyle}>The Practitioner may set their own pricing for scans, including upcharging or bundling the service within their own packages.</li>
      </ul>
      <strong>3.3</strong> Cancellation Policy<br />
      <ul style={listStyle}>
        <li style={listItemStyle}>The Practitioner may cancel their membership at any time, but no prorated refunds will be issued for early cancellations within the first year.</li>
        <li style={listItemStyle}>Cancellations must be submitted in writing via the TruBalance Practitioner App or email to hello@trubalancebioenergetics.com.</li>
        <li style={listItemStyle}>Exception: If the Practitioner selects a monthly support call membership, billing will be discontinued starting from the first date of the next calendar month for the support call fee.</li>
      </ul><br />

      <strong>4. Legal Terms</strong><br /><br />
      <strong>4.1</strong> Severability<br />
      If any provision of this Agreement is found to be unenforceable, all remaining provisions shall remain in full effect.<br /><br />
      <strong>4.2</strong> Limitation of Liability<br />
      TruBalance’s liability is limited to the total amount paid by the Practitioner for services under this Agreement. TruBalance is not liable for any indirect, incidental, or consequential damages.<br /><br />
      <strong>4.3</strong> Modification of Terms<br />
      TruBalance reserves the right to update these terms at any time. Practitioners will be notified of any significant changes. Continued use of TruBalance services constitutes acceptance of updated terms.<br /><br />
      <strong>4.4</strong> Governing Law<br />
      This Agreement shall be governed by and construed in accordance with the laws of the State of Minnesota.<br /><br />

      <strong>5. Agreement Acknowledgment</strong><br /><br />
      By signing up for TruBalance services, the Practitioner acknowledges that they have read, understood, and agreed to the terms outlined in this Agreement. Typing my name in the signature field below signifies that I agree to and accept the terms of this agreement.<br /><br />
      <em>Version: {version}</em>
    </div>
  );
}